import { useState, useEffect, useContext } from 'react';
import './style.css';
import { GeneralSettingsContext } from './Controls';
import worker from './sharedWorker';


export default function DicomLoader() {
  const [numFiles, setNumFiles] = useState(0);
  const [loading, setLoading] = useState(false);

  const generalSettingsContext = useContext(GeneralSettingsContext);
  const interp = generalSettingsContext.settings.interp;



  // Handles folder selection and triggers DICOM loading/parsing
  async function handleFolderChange(files) {
    // Empty folder or user clicked cancelled.
    if (files.length === 0) return;

    setLoading(true);
    worker.postMessage({ action: "loadDicomFiles", payload:{interp, files}});
  
  }

   // Triggers file input dialog for folder selection
  function onBrowse(event) {
    document.getElementById('browseDicomDir').click();
  }

  useEffect(() => {
    const handleWorkerMessage = (e) => {
      const { type, payload } = e.data;
      if (type === 'filesLoaded') {
        setLoading(false);
        setNumFiles(payload || 0);
      }
    };

    worker.addEventListener('message', handleWorkerMessage);
    return () => worker.removeEventListener('message', handleWorkerMessage);
  }, []);

  useEffect(() => {

    worker.postMessage({ action: "resample", payload:interp });

  }, [interp]);



  // Loader UI with branding and folder selection
  return (
    <div className="dicom-loader-box">
      <button
        type="button"
        className="dicom-browse-btn"
        onClick={onBrowse}
        title="Select a folder containing DICOM files"
      >
        <span className="dicom-browse-icon">📂</span> Browse DICOM Folder
      </button>
      <input
        id="browseDicomDir"
        directory=""
        webkitdirectory=""
        type="file"
        onChange={(e) => { 
          handleFolderChange(e.target.files);
          e.target.value = ''; // Reset to allow reloading same folder
        }}
        style={{ display: 'none' }}
      />
      {loading && <div className="dicom-loader-spinner"></div>}
      <p className="dicom-files-loaded">
        {loading
          ? "Reading files, please wait..."
          : `DICOM files loaded: ${numFiles}`}
      </p>
    </div>
  );
}
